import { Fragment, h } from 'preact';
import Footer from '../../components/footer';
import Header from '../../components/header';
import CustomHeight from '../../components/height/custom-height';

import KycSeries from '../../components/series';
import ReviewTab from '../../components/review-tab';
import KycEpisodeReview from '../../components/kyc-episode-review';

const ReviewTwoLayout = props => {
  return (
    <Fragment>
      <Header />
      <div class="container-xl">
        <CustomHeight height="48px" />

        <ReviewTab page="review" path={props.path} />
        <CustomHeight height="24px" />
        <KycSeries path={props.path} />
        <hr />
        {/* <KycEpisodeReview path={props.path} /> */}
        <CustomHeight height="24px" />
        <h3>{props.display}</h3>
        <CustomHeight height="24px" />

        {props.children}
        <CustomHeight height="35px" />

        {/* <CustomHeight height="35vh" /> */}
      </div>

      <Footer />
    </Fragment>
  );
};

export default ReviewTwoLayout;
